// #5100 UI-1e — the closed set of `AskHelixNumericBindingDto.claimDomain`, declared ONCE.
// Consumers derive both the type and the runtime membership check from this tuple
// (AGENTS.md: contracts are single-sourced — never retyped).
export const ASK_HELIX_NUMERIC_CLAIM_DOMAINS = Object.freeze([
  'finance_budget',
  'org_headcount',
  'portfolio_capacity',
  'scenario_target',
  'org_health',
  'risk_index',
  'capability_gap',
  'execution_drift',
  'readiness_score',
  'generic',
] as const);

export type AskHelixNumericClaimDomainDto = (typeof ASK_HELIX_NUMERIC_CLAIM_DOMAINS)[number];
